export default __webpack_public_path__ + "static/media/frg--bbq-entertaining.6bd5d951.png";